import LegalLink from '@/components/legalLinks/components/legalLink';
import { type Brand } from '@/consts/brands';
import { urls } from '@/utils/urls';

const TelehealthConsent = ({ brand }: { brand: Brand }) => {
  return (
    <LegalLink
      dataTestId="telehealth-consent"
      title="Telehealth Consent"
      src={urls[brand].site.legal.telehealthConsent}
      type="TelehealthConsent"
    />
  );
};

export default TelehealthConsent;
